import { useEffect, useState, useReducer } from "react";
import Select from "react-select";
import { optionSelector } from "../../config/apiSPA.js";

const initialValue = {
  trainingTitle: "",
  atmp: false,
  kpi: false,
  location: "",
  institution: "",
  instructor: "",
  startDate: "",
  endDate: "",
  eval: true,
  remark: "",
};
function reducer(state, action) {
  switch (action.type) {
    case "trainingTitle": {
      return { ...state, trainingTitle: action.value };
    }
    case "atmp": {
      return { ...state, atmp: action.value, kpi: action.value };
    }
    case "kpi": {
      return { ...state, kpi: action.value };
    }
    case "eval": {
      return { ...state, eval: action.value };
    }
    case "location": {
      return { ...state, location: action.value };
    }
    case "institution": {
      return { ...state, institution: action.value };
    }
    case "instructor": {
      return { ...state, instructor: action.value };
    }
    case "startDate": {
      return { ...state, startDate: action.value };
    }
    case "endDate": {
      return { ...state, endDate: action.value };
    }
    case "remark": {
      return { ...state, remark: action.value };
    }
    case "resetReducer": {
      return initialValue;
    }
  }
}

function ReportEvent({ onUpdate = () => {} }) {
  const [eventData, eventDataDispatch] = useReducer(reducer, initialValue);
  const [listTrainingTitle, setListTrainingTitle] = useState([]);
  const [listLocation, setListLocation] = useState([]);
  const [listInstitution, setListInstitution] = useState([]);
  const [listInstructor, setListInstructor] = useState([]);
  function resetForm() {
    eventDataDispatch({ type: "resetReducer" });
  }

  useEffect(() => {
    onUpdate(eventData);
  }, [eventData]);
  useEffect(() => {
    resetForm();
    optionSelector(`/trainingTitle`).then((res) => setListTrainingTitle(res));
    optionSelector(`/location`).then((res) => setListLocation(res));
    optionSelector(`/institution`).then((res) => setListInstitution(res));
    optionSelector(`/instructor`).then((res) => setListInstructor(res));
  }, []);
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-12">
            <div className="row">
              <div className="col-xl-12">
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="title">
                    Training Title<span className="text-danger">*</span>
                  </label>
                  <Select id="title" options={listTrainingTitle} onChange={(e) => eventDataDispatch({ type: "trainingTitle", value: e.value })} classNamePrefix="react-select" />
                </div>
                <AtmpInput value={eventData.atmp} onChange={(e) => eventDataDispatch({ type: "atmp", value: e })} />
                <KPISelector value={eventData.kpi} onChange={(e) => eventDataDispatch({ type: "kpi", value: e })} />
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="location">
                    Location<span className="text-danger">*</span>
                  </label>
                  <Select id="location" options={listLocation} onChange={(e) => eventDataDispatch({ type: "location", value: e.value })} classNamePrefix="react-select" />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="institution">
                    Institution<span className="text-danger">*</span>
                  </label>
                  <Select id="institution" options={listInstitution} onChange={(e) => eventDataDispatch({ type: "institution", value: e.value })} classNamePrefix="react-select" />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="instructor">
                    Instructor<span className="text-danger">*</span>
                  </label>
                  <Select id="instructor" options={listInstructor} onChange={(e) => eventDataDispatch({ type: "instructor", value: e.value })} classNamePrefix="react-select" />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="startDate">
                    Start Date<span className="text-danger">*</span>
                  </label>
                  <input type="date" onChange={(e) => eventDataDispatch({ type: "startDate", value: e.target.value })} className="form-control" id="startDate" />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="endDate">
                    End Date<span className="text-danger">*</span>
                  </label>
                  <input type="date" onChange={(e) => eventDataDispatch({ type: "endDate", value: e.target.value })} className="form-control" id="endDate" />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="remark">
                    Remark
                  </label>
                  <textarea onChange={(e) => eventDataDispatch({ type: "remark", value: e.target.value })} className="form-control" id="remark"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReportEvent;

function KPISelector({ value, onChange }) {
  function changeState(val) {
    onChange(val);
  }

  return (
    <>
      <div className="col-xl-6 mb-3">
        <div className="small text-theme mb-1">
          <b>Count as KPI?</b>
        </div>
        <div className="form-group mb-4">
          <div className="form-check">
            <input checked={value === true} onChange={(e) => changeState(true)} className="form-check-input" type="radio" name="radio_2" id="defaultRadio1" />
            <label className="form-check-label" htmlFor="defaultRadio1">
              Yes
            </label>
          </div>
          <div className="form-check">
            <input checked={value === false} onChange={(e) => changeState(false)} className="form-check-input" type="radio" name="radio_2" id="defaultRadio2" />
            <label className="form-check-label" htmlFor="defaultRadio2">
              NO
            </label>
          </div>
        </div>
      </div>
    </>
  );
}
function AtmpInput({ value, onChange }) {
  function changeState(val) {
    onChange(val);
  }

  return (
    <>
      <div className="col-xl-6 mb-3">
        <div className="small text-theme mb-1">
          <b>ATMP/NON ATMP ?</b>
        </div>
        <div className="form-group mb-4">
          <div className="form-check">
            <input checked={value === true} onChange={(e) => changeState(e.target.checked)} className="form-check-input" type="radio" name="radio_1" id="defaultRadio1" />
            <label className="form-check-label" htmlFor="defaultRadio1">
              ATMP
            </label>
          </div>
          <div className="form-check">
            <input checked={value === false} onChange={(e) => changeState(!e.target.checked)} className="form-check-input" type="radio" name="radio_1" id="defaultRadio2" />
            <label className="form-check-label" htmlFor="defaultRadio2">
              non-ATMP
            </label>
          </div>
        </div>
      </div>
    </>
  );
}
